import React, { useContext, useEffect, useRef, useState } from 'react'

//components
import RateAppModal from './RateAppModal'
//contexts
import AuthContext from 'context/AuthContext'
//hooks
import useUserFeedbackConfig from 'hooks/useUserFeedbackConfig'
//utils
import { displayRateAppNotif } from 'utils/userFeedback'

interface RateAppPromptProps {
  canOpen: boolean
}

interface RedeemedValueSnapshot {
  userId: string
  value: number
}

const RateAppPrompt = ({ canOpen }: RateAppPromptProps) => {
  const { user } = useContext(AuthContext)
  const userFeedbackConfig = useUserFeedbackConfig()
  const previousRedeemedValue = useRef<RedeemedValueSnapshot | null>(null)
  const [isPending, setPending] = useState(false)
  const [isModalDisplayed, setModalDisplayed] = useState(false)
  const [promptKey, setPromptKey] = useState(0)

  const userId = user?.id
  const redeemedValue = user?.allGiftCardValueRedeemed ?? 0

  useEffect(() => {
    if (!userId) {
      previousRedeemedValue.current = null
      setPending(false)
      setModalDisplayed(false)
      return
    }

    const previous = previousRedeemedValue.current
    previousRedeemedValue.current = { userId, value: redeemedValue }

    if (!previous || previous.userId !== userId) {
      return
    }

    if (redeemedValue > previous.value) {
      setPending(true)
    }
  }, [redeemedValue, userId])

  useEffect(() => {
    if (!isPending || !canOpen || !userFeedbackConfig) {
      return
    }

    setPending(false)
    if (displayRateAppNotif(user, userFeedbackConfig)) {
      setPromptKey((currentKey) => currentKey + 1)
      setModalDisplayed(true)
    }
  }, [canOpen, isPending, user, userFeedbackConfig])

  return (
    <RateAppModal
      key={promptKey}
      isModalDisplayed={isModalDisplayed}
      hideModal={() => setModalDisplayed(false)}
    />
  )
}

export default RateAppPrompt
